import { UnitType } from '@exodus/currency'

const name = 'axelar'
const displayName = 'Axelar'
const ticker = 'AXL'
const displayTicker = 'AXL'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#0197FE'
const gradientColors = ['#0197FE', '#52B8FF']
const gradientCoords = { x1: '37%', y1: '39%', x2: '-1.155%', y2: '4.911%' }
const chainBadgeColors = gradientColors

const units = {
  uaxl: 0,
  AXL: 6,
}

const currency = UnitType.create(units)

const assetType = 'COSMOS_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://mintscan.io/axelar/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://www.mintscan.io/axelar/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Axelar is a permissionless network and gateway that delivers secure cross-chain communication for Web3 and enables you to build cross-chain applications.',
  twitter: 'https://twitter.com/axelarnetwork',
  website: 'https://axelar.network/',
  telegram: 'https://t.me/axelarcommunity',
  discord: 'https://discord.com/invite/aRZ3Ra6f7D',
}

export const asset = {
  assetType,
  baseAssetName,
  baseDenom: 'uaxl',
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
